//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.ItemType

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The order item model
* 
* @param contingentTitle The localized contingent title
* @param eventBeginsAt The date and time when the event begins
* @param eventTitle The localized event title
* @param orderItemId The order item id
* @param quantity The quantity of this product
* @param venueName The venue name
* @param eventSubTitle The localized event subtitle
* @param itemType 
*/
@Serializable

data class OrderItem (


      /* The localized contingent title */
    @SerialName(value = "contingentTitle") @Required val contingentTitle: kotlin.String,


      /* The date and time when the event begins */
    @SerialName(value = "eventBeginsAt") @Required val eventBeginsAt: kotlin.time.Instant,


      /* The localized event title */
    @SerialName(value = "eventTitle") @Required val eventTitle: kotlin.String,


      /* The order item id */
    @SerialName(value = "orderItemId") @Required val orderItemId: kotlin.Int,


      /* The quantity of this product */
    @SerialName(value = "quantity") @Required val quantity: kotlin.Int,


      /* The venue name */
    @SerialName(value = "venueName") @Required val venueName: kotlin.String,


      /* The localized event subtitle */
    @SerialName(value = "eventSubTitle") val eventSubTitle: kotlin.String? = null,


      @SerialName(value = "itemType") val itemType: ItemType? = null


) {




  }

